import EmptyStatesPreview from '../content/EmptyStatesPreview'
import { Dash } from '@eggplant/pattern-library/src/lib/components/Artwork/Artwork'
import { LinkToMonitorAvailabilityDashboardDoc } from '../links'
import { MonitorConfigConsumer } from '@eggplant/context'
import { SelectModelSuiteMonitorConfigs } from '@eggplant/input-controls'

const description = `Monitor availability shows the run status of your selected monitor configuration and the runtime details of its test cases over a specific period.

📝 Add monitor configurations and run them to see their data.`

const renderButton = () =>
  <MonitorConfigConsumer>
    {
      ({
        selectedMonitorConfigId,
        setSelectedMonitorConfigId
      }) =>
        <SelectModelSuiteMonitorConfigs
          onChange={setSelectedMonitorConfigId}
          placeholder='Monitor Config'
          shortErrorMessage='Failed to load monitor configs'
          value={selectedMonitorConfigId || ''}
        />
    }
  </MonitorConfigConsumer>

const MonitorAvailabilityDashboardIntro = () =>
  <div className='grid h-full justify-center'>
    <div className='grid w-[36em]'>
      <EmptyStatesPreview
        action={renderButton()}
        description={description}
        icon={<Dash />}
        renderLink={<LinkToMonitorAvailabilityDashboardDoc />}
        title='Monitor Availability'
      />
    </div>
  </div>

export default MonitorAvailabilityDashboardIntro
